'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { getFullHref } from '../util/History';

var Canonical = function Canonical(_ref) {
  var rel = _ref.rel,
      to = _ref.to;
  return /*#__PURE__*/_jsx("link", {
    rel: rel,
    href: getFullHref(to)
  });
};

Canonical.propTypes = {
  rel: PropTypes.oneOf(['canonical', 'next', 'prev']),
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
};
Canonical.defaultProps = {
  rel: 'canonical'
};
export default Canonical;